import { ResponsiveContainer, ComposedChart, CartesianGrid, XAxis, YAxis, Bar, Tooltip, Label, Legend } from 'recharts'

const colors = [
  '#e60049',
  '#0bb4ff',
  '#50e991',
  '#9b19f5',
  '#e6d800',
  '#ffa300',
  '#dc0ab4',
  '#00bfa0',
  '#4421af',
  '#b3d4ff',
  '#D9561E',
  '#2781DB',
  '#54DB40',
  '#C395E6',
  '#DBBB5F'
]

const getColor = (idx) => {
  if (colors[idx]) {
    return colors[idx]
  }
  return colors[idx % colors.length]
}

const getEndpoints = (graphData = []) => {
  const endpoints = []
  graphData.forEach(record => {
    Object.keys(record).forEach(key => {
      if ((typeof (record[key]) === 'number' && key !== 'hits') && !endpoints.includes(key)) {
        endpoints.push(key)
      }
    })
  })
  return endpoints
}

const Graph = ({ graphData }) => {
  const ENDPOINTS = getEndpoints(graphData)
  let interval = 3

  if (graphData) {
    if (graphData.length <= 13) {
      interval = 0
    } else if (graphData.lengh <= 15) {
      interval = 1
    } else {
      interval = 3
    }
  }

  if (graphData) {
    return (
      <div className='bg-zinc-100 p-4 m-4 rounded-sm'>
        <ResponsiveContainer height={650} width='80%'>
          <ComposedChart data={graphData} margin={{ top: 5, right: 10, bottom: 25, left: 50 }}>
            <CartesianGrid stroke='#ccc' strokeDasharray='7' />
            <XAxis dataKey='xLabel' interval={interval}>
              <Label className='text-2xl' position='bottom'>
                Time
              </Label>
            </XAxis>
            <YAxis allowDecimals={false}>
              <Label value='Hits' position='left' />
            </YAxis>
            <Tooltip />
            {ENDPOINTS.map((endpoint, idx) => {
              return <Bar isAnimationActive={false} key={`endpoint_${endpoint}`} fill={getColor(idx)} dataKey={endpoint} stackId='a' barSize={12} />
            })}
            <Legend layout='vertical' align='right' wrapperStyle={{ marginRight: '-80px', marginBottom: '120px', position: 'absolute' }} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>

    )
  }
}

export default Graph
